import { EXPORT, INFO } from "../iconsSVG/IconsSVG";
import { Row, Col, Accordion } from "react-bootstrap";

function BopiHistorico() {
  return (
    <div>
      <Row>
        <Col xs={3}></Col>
        <Col xs={6} className="d-flex align-items-center justify-content-center">
        {/* <div > */}
          <h2 style={{ fontSize: '1.5em' }} className="m-0 p-0 d-flex flex-row justify-content-center">
            Acceso a BOPI HISTÓRICO &nbsp; 
          </h2>
          <a href="https://spain.iprgazettes.org/" target="_blank" title="Abre en una nueva pestaña" className="align-items-start ExportIcon-link m-0 p-0 pb-1">
            <EXPORT 
              color_icono="#203C77" 
              color_fondo="var(--icon-bg-color)" 
            />
          </a>
        {/* </div> */}
        </Col>
        <Col xs={3}></Col>
      </Row>
      <br/>
      <div className="center">
        <Accordion defaultActiveKey="0" className="w-100 glob-custom-accordion-button-color">
          <Accordion.Item eventKey="0">
            <Accordion.Header>              
              <div className="fondo-blanco-icono justify-content-start">
                <INFO color_icono="#203C77" color_fondo="#E9F1F7" className="p-0 m-0"/>
              </div>
              <span className="p-0 m-0 ps-3 pb-1">Información</span>
            </Accordion.Header>
            <Accordion.Body>
              <p className="px-5" style={{ fontSize: '13px', fontWeight: '100 !important' }}>
                ACCESO A LA COLECCIÓN HISTÓRICA DEL BOPI (BOLETÍN OFICIAL DE LA
                PROPIEDAD INDUSTRIAL DE ESPAÑA, 1886-1997) El Boletín de la
                Propiedad Industrial e Intelectual nace por Real Decreto de 2 de
                agosto de 1886.
                <br /> <br />
                El Boletín fue digitalizado por la OEPM para su puesta a disposición
                del público y la UAM (Universidad Autónoma de Madrid) con el equipo
                de investigación que ha realizado la página web y las bases de datos
                de historia de la propiedad industrial de España ha desarrollado
                una herramienta para su consulta accesible a través de la Web.{" "}
                <br /> <br />
                Importante: Para realizar las búsquedas, emplee las casillas ubicadas
                en la parte superior derecha búsqueda amplia, búsqueda por frase y
                búsqueda combinada e introduzca los términos de búsqueda.
              <br /> <br />
              </p>
              <p className="p-3" style={{ fontSize: '13px', fontWeight: '100 !important' }}>
                Para cualquier consulta puede dirigirse a{" "}
                <a href="mailto:informacion@oepm.es">informacion@oepm.es</a>
              </p>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </div>
  );
}

export default BopiHistorico;